import { createSlice } from '@reduxjs/toolkit';
import {
  getThirdPartyIntegrationsWithPaginationReducers,
  getThirdPartyIntegrationReducers,
  updateThirdPartyIntegrationReducers,
  getThirdPartyIntegrationsListReducers,
  orderSupplierTaggingReducers,
  shipStationSalesOrderNumberMappingReducers,
  shipStationTaggerReducers,
} from './third-party-integrations.reducers';

const initialState = {
  thirdPartyIntegration: null,

  thirdPartyIntegrations: [],
  totalThirdPartyIntegrations: 0,
  totalPages: 0,
  currentPage: 1,

  getThirdPartyIntegrationsStatus: 'idle',
  getThirdPartyIntegrationStatus: 'idle',
  updateThirdPartyIntegrationStatus: 'idle',
  orderSupplierTaggingStatus: 'idle',
  shipStationSalesOrderNumberMappingStatus: 'idle',

  shipStationTaggerSchedule: null,
  shipStationTaggerProcessStatus: null,
  isShipStationTaggerRunning: false,
  getShipStationTaggerScheduleStatus: 'idle',
  updateShipStationTaggerScheduleStatus: 'idle',
  downloadShipStationTaggerReportStatus: 'idle',

  list: [],
  getThirdPartyIntegrationsListStatus: 'idle',

  error: null,
};

const thirdPartyIntegrationsSlice = createSlice({
  name: 'thirdPartyIntegrations',
  initialState,
  reducers: {
    setShipStationTaggerProcessStatusFromSocket(state, action) {
      state.shipStationTaggerProcessStatus = action.payload;
      state.isShipStationTaggerRunning = Boolean(action.payload?.isRunning);
    },
  },
  extraReducers: (builder) => {
    getThirdPartyIntegrationsWithPaginationReducers(builder);
    getThirdPartyIntegrationReducers(builder);
    updateThirdPartyIntegrationReducers(builder);
    getThirdPartyIntegrationsListReducers(builder);
    orderSupplierTaggingReducers(builder);
    shipStationSalesOrderNumberMappingReducers(builder);
    shipStationTaggerReducers(builder);
  },
});

export const { setShipStationTaggerProcessStatusFromSocket } =
  thirdPartyIntegrationsSlice.actions;

export default thirdPartyIntegrationsSlice.reducer;
